module.exports = __webpack_public_path__ + "media/images/logo-salesforce-7ecd97d6b45372621230131965e38e36.svg";